import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper, TextField,
  Button,
} from "@mui/material";
import { Pagination, Select, SelectItem, Skeleton, Spinner } from "@heroui/react";
import { EyeIcon, KeyboardArrowDownIcon, KeyboardArrowUpIcon } from "../../utils/svgIcons";
import LeadHistoryModal from "../PopupModals/LeadHistoryModal";
import { FaEye } from "react-icons/fa";
import GetLeadDetails from "./GetLeadDetails";
import GetCommonLeadsDetails from "../../utils/GetCommonLeadsDetails";
import LeadViewModal from "../PopupModals/LeadDetailViewModal";
import SendSimpleLeadModal from "../PopupModals/SendSimpleLeadModal";
import { useAuth } from "../../hooks/useAuth";
import toast from "react-hot-toast";
import { MdOutlinePlayCircleOutline } from "react-icons/md";
import { FiSend, FiAlertCircle, FiX, FiEdit2, FiCheck, FiClock } from "react-icons/fi";
import { IoCheckmark } from "react-icons/io5";


export const pageLimitsNumber = [
  { value: "10", label: "10", key: "10", },
  { value: "20", label: "20", key: "20" },
  { value: "50", label: "50", key: "50" },
  { value: "100", label: "100", key: "100" },
  { value: "150", label: "150", key: "150" },
];

const formatDate = (isoString) => {
  if (!isoString) return "-";

  const date = new Date(isoString);

  // Format date manually as DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  // Format time using toLocaleTimeString
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });

  return `${formattedDate}, ${formattedTime}`;
};

// Collapsible Row Component
function Row({ row, columns, index, currentPage, pageLimit, HandleLeadDetails, leadType, handleGetLeadDetails, handleVIewLeadDetailsInaccordion, leadDetailsMap, isFetchingleadDetails, loadingId, handleGetRecordingUrl, recordingUrls, loadingRecordingById, onUpdateLeadState, onToggleAccordion, simpleVariants }) {

  const indexValue = (currentPage - 1) * pageLimit + (index + 1);
  const [open, setOpen] = useState(false);
  const [rowState, setRowState] = useState(row);
  const [isUpdatingCall, setIsUpdatingCall] = useState(false);
  const [isSendingToSimple, setIsSendingToSimple] = useState(false);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const { user, permissionsFlag } = useAuth();
  const hasSendPermission = Boolean(user?.type === 'SUPER' || (Array.isArray(permissionsFlag) && permissionsFlag.some((p) => p?.key === 'SIMPLE_LEAD_SEND' || p?.key === 'SUPER_ADMIN')));

  useEffect(() => {
    setRowState(row);
  }, [row]);

  const handleUpdateCallVerification = async (newVal) => {
    try {
      setIsUpdatingCall(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/simple-leads/update-call-verification`, {
        leadId: rowState._id,
        status: Number(newVal)
      });
      if (res.data?.success) {
        toast.success(res.data.message || 'Updated verification status');
        setRowState(prev => ({ ...prev, simple_call_verification: Number(newVal) }));
        if (onUpdateLeadState) {
          onUpdateLeadState(rowState._id, { simple_call_verification: Number(newVal) });
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update verification');
    } finally {
      setIsUpdatingCall(false);
    }
  };

  const [isUpdatingVehicle, setIsUpdatingVehicle] = useState(false);
  const [isEditingPincode, setIsEditingPincode] = useState(false);
  const [pincodeInput, setPincodeInput] = useState("");
  const [isSavingPincode, setIsSavingPincode] = useState(false);

  const startPincodeEdit = () => {
    setPincodeInput(rowState.pincode ? String(rowState.pincode) : "");
    setIsEditingPincode(true);
  };

  const cancelPincodeEdit = () => {
    if (isSavingPincode) return;
    setIsEditingPincode(false);
    setPincodeInput("");
  };

  const handleSavePincode = async () => {
    const newPin = pincodeInput.trim();
    if (!/^[1-9]\d{5}$/.test(newPin)) {
      toast.error('Enter a valid 6-digit pincode');
      return;
    }
    if (newPin === String(rowState.pincode || "")) {
      cancelPincodeEdit();
      return;
    }
    try {
      setIsSavingPincode(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/simple-leads/update-pincode`, {
        leadId: rowState._id,
        pincode: newPin
      });
      if (res.data?.success) {
        toast.success(res.data.message || 'Pincode updated');
        const { leadId, ...updates } = res.data.result || {};
        setRowState(prev => ({ ...prev, ...updates }));
        if (onUpdateLeadState) {
          onUpdateLeadState(rowState._id, updates);
        }
        setIsEditingPincode(false);
        setPincodeInput("");
      } else {
        toast.error(res.data?.message || 'Failed to update pincode');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update pincode');
    } finally {
      setIsSavingPincode(false);
    }
  };

  const handleUpdateVehicle = async (modelId) => {
    try {
      setIsUpdatingVehicle(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/simple-leads/update-vehicle`, {
        leadId: rowState._id,
        modelId: modelId || ''
      });
      if (res.data?.success) {
        toast.success(res.data.message || 'Vehicle updated');
        const updates = {
          simple_selected_model_id: res.data.result?.simple_selected_model_id || '',
          simple_selected_model: res.data.result?.simple_selected_model || ''
        };
        setRowState(prev => ({ ...prev, ...updates }));
        if (onUpdateLeadState) {
          onUpdateLeadState(rowState._id, updates);
        }
      } else {
        toast.error(res.data?.message || 'Failed to update vehicle');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update vehicle');
    } finally {
      setIsUpdatingVehicle(false);
    }
  };

  const handleSendLeadToSimple = async () => {
    try {
      setIsSendingToSimple(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/simple-leads/send-lead`, {
        leadId: rowState._id
      });
      if (res.data?.success) {
        toast.success(res.data.message || 'Lead sent to Simple Energy');
        setRowState(prev => ({ ...prev, pushed_to_simple: 1, simple_verification: 1 }));
      } else {
        toast.error(res.data?.message || 'Failed to send lead');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error sending lead to Simple Energy');
    } finally {
      setIsSendingToSimple(false);
    }
  };
  const [sourceType] = useState(
    {
      1: 'Landing Page', 2: 'Fresh Work', 3: 'FTBV', 4: 'Inquiry',
      5: 'Whatsapp', 6: 'New Fresh Marketer', 7: 'BotBuz', 8: 'Excel', 9: 'Vidyut Freshmarketer', 10: 'RENAV-FORM-INQUIRY',
      11: 'TVS-LP', 12: 'RENAV-WHATSAPP', 13: 'HP-LP', 14: 'VIDA-LP', 15: 'CL', 16: 'TP', 17: 'DS', 18: 'RENAV-MISSED-CALL',
      19: 'RENAV-WHATSAPP-547', 20: 'RENAV-WHATSAPP-348', 21: 'RENAV-WHATSAPP-563', 22: 'RENAV-WHATSAPP-507',
      23: 'RENAV-WHATSAPP-742', 24: 'DIRECT-EXCEL', 25: "DIALSHREE-INBOUND-LEADS", 26: "OLA-EXCEL-IMPORT", 27: "GOOGLE-ADS", 28: "AMPERE-EXCEL-IMPORT", 29: "RETARGETTING", 30: "Listing Page"
    }
  )

  const [FORM_TYPE] = useState({
    1: "Test Ride", 2: "On Road Price", 3: "Get Offers", 4: "Home Test Ride", 5: " Loan",
  });


  return (
    <>
      <TableRow id={`left-main-row-${row._id}`} sx={{ "& > *": { borderBottom: "unset" } }} className="border-none removed-border-bottom">
        <TableCell className={`border-none removed-border !flex !flex-row gap-4 !py-[12px] !h-[58px] ${open ? "openedaccordion" : ""}`}>
          {(leadType !== 'Dialshree' && leadType !== 'Dialshreeinbound') && (
            <IconButton aria-label="expand row" size="small" onClick={() => {
              handleVIewLeadDetailsInaccordion(row._id);
              const nextOpen = !open;
              setOpen(nextOpen);
              if (onToggleAccordion) {
                onToggleAccordion(row._id, nextOpen);
              }
            }} >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}


          {(leadType !== 'Dialshreeinbound') && (
            <IconButton aria-label="expand row" size="small" onClick={() => handleGetLeadDetails(leadType === 'Dialshree' ? row?._id : row.mobile)}>
              <FaEye color="#487192" />
            </IconButton>
          )}
        </TableCell>

        <TableCell className={`border-none removed-border !py-[12px] !h-[58px] ${open ? "openedaccordion" : ""}`}>
          <p className="text-black text-medium font-bold">{indexValue}</p>
        </TableCell>

        {/* Render Dynamic Columns */}
        {columns.map((col) => (
          <TableCell key={col.uid} align="left" className={`removed-border border-none !py-[12px] !h-[58px] whitespace-nowrap ${open ? "openedaccordion" : ""}`}>
            {(() => {
              const value = row[col.uid];

              switch (col.uid) {
                case "createdAt":
                case "updatedAt":
                case "ola_expiry":
                  return formatDate(value);

                case "olaverificationdate":
                  return formatDate(value);

                case "source":
                  return (
                    <div className="bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3">
                      {sourceType[value] || value}
                    </div>
                  );

                case "formType":
                  return (
                    <div className="bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3">
                      {FORM_TYPE[value] || value}
                    </div>
                  );

                case "freshworkbrand":
                  return (
                    <div className={`${value ? 'bg-success inline-block text-white text-center rounded-global shadow-md text-[14px] py-1 px-3' : 'bg-white text-black'} py-1 px-3 rounded-global shadow-md inline-block`}>
                      {value || 'N/A'}
                    </div>
                  );

                case "pushed_to_revolt":
                  return (
                    <div
                      className={`${value === 1 ? "bg-accepted" : value === 2 ? "bg-danger" : value === 3 ? "bg-gray-300" : "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md text-white inline-block`}
                    >
                      {loadingId === row?._id ? (
                        <Spinner color="default" key={row._id} size="sm" />
                      ) : (
                        <>
                          {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Not eligible" : "N/A"}
                        </>
                      )}
                    </div>
                  );

                case 'evfin': {
                  const val = value ?? row.evfin;
                  return (
                    <div className={val === 1 ? 'text-accepted font-semibold' : val === 2 ? 'text-danger font-semibold' : ''}>{val === 1 ? 'Available' : val === 2 ? 'Unavailable' : '-'}</div>
                  );
                }

                case 'ecofy': {
                  const val = value ?? row.ecofy;
                  return (
                    <div className={val === 1 ? 'text-accepted font-semibold' : val === 2 ? 'text-danger font-semibold' : ''}>{val === 1 ? 'Available' : val === 2 ? 'Unavailable' : '-'}</div>
                  );
                }

                case 'ampereAvailable':
                case 'ampere_available':
                case 'ampere_available_status': {
                  const val = value ?? row?.ampereAvailable ?? row?.ampere_available;
                  const isAvail = val === 1 || val === "1" || val === "Available" || val === true;
                  const isUnavail = val === 2 || val === "2" || val === "Unavailable" || val === "Not Available" || val === false;
                  return (
                    <div className={isAvail ? 'text-accepted font-semibold' : isUnavail ? 'text-danger font-semibold' : ''}>
                      {isAvail ? 'Available' : isUnavail ? 'Unavailable' : '-'}
                    </div>
                  );
                }


                case "pushed_to_tvs":
                  return (
                    <div
                      className={`${value === 1 ? "bg-accepted text-white" :
                        value === 2 ? "bg-yellow-300 !text-black" :
                          value === 3 ? "bg-danger text-white" :
                            value === 4 ? "bg-gray-400 text-white" :                     // Not Eligible
                              value === 5 ? "bg-blue-600 text-white" :                   // DUPLICATE_LEAD
                                value === 6 ? "bg-danger text-white" :                     // Failed to allocate dealer
                                  value === 7 ? "bg-indigo-400 text-white" :                   // INVALID_PINCODE
                                    value === 8 ? "bg-green-600 text-white"
                                      : "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md text-white inline-block`}
                    >
                      {
                        value === 1 ? "Completed" :
                          value === 2 ? "Pending" :
                            value === 3 ? "Rejected" :
                              value === 4 ? "Not Eligible" :
                                value === 5 ? "DUPLICATE_LEAD" :
                                  value === 6 ? "Failed to allocate dealer" :
                                    value === 7 ? "INVALID_PINCODE" :
                                      value === 8 ? "Success" :
                                        "N/A"
                      }
                    </div>
                  );

                case "tvs_verification":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "tvs_history")}
                      className={`${value === 1 ? "bg-accepted text-white" :
                        value === 2 ? "bg-danger text-white" :
                          value === 3 ? "bg-info text-white" :
                            value === 4 ? "bg-blue-500 text-white" :
                              value === 5 ? "bg-danger text-white" :
                                value === 6 ? "bg-black text-white" :
                                  value === 7 ? "bg-gray-300 text-white" :
                                    "bg-white !text-black"} 
                    py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                    >
                      {loadingId === row?._id ? (
                        <Spinner color="default" key={row._id} size="sm" />
                      ) : (
                        <>
                          {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Un Processed" : value === 4 ? "Duplicate" : value === 5 ? "Dealer Not Found" : value === 6 ? "Old Leads" : value === 7 ? "Not Eligible" : "N/A"}
                        </>
                      )}
                    </div>
                  );

                case "tvs_status":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "tvs_status_history")}
                      className={`${value === 'Retailed' ? "bg-accepted text-white" : value === 'Expired' ? "bg-danger text-white" : value === 'Open' ? "bg-yellow-300 text-white" : "bg-white !text-black"} 
                    py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                    >
                      {loadingId === row?._id ? (
                        <Spinner color="default" key={row._id} size="sm" />
                      ) : (
                        <>
                          {value ? value : "N/A"}
                        </>
                      )}
                    </div>
                  );


                case "type":
                  return (["Test Ride", "On Road Price", "Offers", "Home Test Ride", "Loan"][value - 1] || "N/A");

                case "revolt_Lead_Process":
                  return (
                    <>
                      <div
                        onClick={() => HandleLeadDetails(row._id, "revolt_history")}
                        className={`${value === 1 ? "!bg-accepted" :
                          value === 0 ? "bg-yellow-300 !text-black" :
                            value === 2 ? 'bg-blue-500 text-white' :
                              value === 3 ? "bg-danger" :
                                value === 4 ? "bg-gray-300" :
                                  "bg-white !text-black"
                          }
                             py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        {loadingId === row?._id ? (
                          <Spinner color="default" key={row._id} size="sm" />
                        ) : (
                          <>
                            {value === 0 ? 'Pending' :
                              value === 1 ? 'Completed' :
                                value === 2 ? 'Duplicate' :
                                  value === 3 ? 'Failed' :
                                    value === 4 ? 'Not eligible' : 'NA'}
                          </>
                        )}
                      </div>
                    </>
                  );

                case "revolt_status":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "revolt_status_history")}
                      className={`${value === 1 ? "bg-green-600 text-white" :
                        value === 2 ? "bg-blue-500 text-white" :
                          value === 3 ? "bg-purple-500 text-white" :
                            value === 4 ? "bg-orange-400 text-white" :
                              "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md inline-block !cursor-pointer`}
                    >
                      {loadingId === row?._id ? (
                        <Spinner color="default" key={row._id} size="sm" />
                      ) : (
                        <>
                          {value === 1 ? "Retailed" :
                            value === 2 ? "Booked" :
                              value === 3 ? "TR Completed" :
                                value === 4 ? "TR Scheduled" : "-"}
                        </>
                      )}
                    </div>
                  );

                case "revolt_retail_date":
                case "revolt_booking_date":
                case "revolt_tr_completed_date":
                case "revolt_tr_scheduled_date":
                  return formatDate(value);

                case "pushed_to_ampere":
                  return (
                    <>
                      <div
                        onClick={() => HandleLeadDetails(row._id, "ampere_history")}
                        className={`${value === 1 ? "bg-accepted" :
                          value === 2 ? "bg-danger" :
                            value === 3 ? 'bg-blue-500 text-white' :
                              value === 4 ? 'bg-gray-300 text-white' :
                                "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        {loadingId === row?._id ? (
                          <Spinner color="default" key={row._id} size="sm" />
                        ) : (
                          <>
                            {value === 1 ? "Success" : value === 2 ? "UnSuccess" : value === 3 ? "Duplicate" : value === 4 ? "Not eligible" : "N/A"}
                          </>
                        )}
                      </div>
                    </>
                  );

                case "ola_verification":
                  return (
                    <>
                      <div
                        onClick={() => HandleLeadDetails(row._id, "ola_history")}
                        className={`${value === 1 ? "bg-accepted" :
                          value === 2 ? "bg-danger" :
                            value === 3 ? 'bg-danger' :
                              value === 4 ? "bg-blue-500 text-white" :
                                value === 7 ? 'bg-yellow-600 text-black' :
                                  value === 8 ? 'bg-purple-600 text-white' :
                                    value === 5 ? 'bg-gray-300 text-white' :
                                      "bg-white !text-black"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        {loadingId === row?._id ? (
                          <Spinner color="default" key={row._id} size="sm" />
                        ) :
                          (
                            <>
                              {
                                value === 1 ? "Accepted" :
                                  value === 2 ? "Rejected" :
                                    value === 3 ? "Un Processed" :
                                      value === 4 ? "Duplicate" :
                                        value === 7 ? "Store(B)" :
                                          value === 8 ? "Store(A)" :
                                            value === 5 ? "Not Eligible" :
                                              "N/A"}
                            </>
                          )}
                      </div>
                    </>
                  );

                case "dialshreeResponse":
                  const dialShreeResponse = value?.data?.reverse().map((lead, i) => {
                    return lead?.status;
                  })
                  return (
                    <>
                      <div
                        // onClick={() => HandleLeadDetails(row._id, "dialshreeResponse")}
                        className={`${dialShreeResponse === true ? "bg-accepted" : "bg-danger bg-whit"} py-1 px-3 rounded-global shadow-md text-white inline-block !cursor-pointer`}
                      >
                        {dialShreeResponse === true ? "Success" : "Failed" || "N/A"}
                      </div>
                    </>
                  );

                case "lead_send_to":
                  const leadSendto = (value && value?.length > 0) ? value.map(a => a === 1 ? 'Ola' : 'N/A').join(',') : value?.length === 0 ? 'N/A' : 'N/A';
                  return (
                    <>
                      <div className={`${leadSendto === 'N/A' ? "bg-danger" : leadSendto === '' ? "bg-white !text-black" : "bg-accepted"} py-1 px-3 rounded-global shadow-md text-white inline-block`}>
                        {leadSendto}
                      </div>
                    </>
                  );

                case "recording_url":
                  return (
                    <>
                      {recordingUrls[row._id] ? (
                        <div>
                          <audio
                            controls
                            className="w-full rounded"
                            style={{ maxWidth: "300px", width: "300px" }}
                          >
                            <source src={recordingUrls[row._id]} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      ) : loadingRecordingById === row._id ? (
                        <div className="text-blue-500 animate-pulse">
                          Loading recording...
                        </div>
                      ) : (
                        <Button
                          onClick={() => handleGetRecordingUrl(row._id)}
                          className="!text-success px-3 py-1 rounded !capitalize"
                          startIcon={<MdOutlinePlayCircleOutline />}
                        >
                          Play Recording
                        </Button>
                      )}
                    </>
                  );




                case "simple_verification":
                case "simple_status":
                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "simple_history")}
                      className={`${value === 1 ? "bg-accepted text-white" :
                        value === 2 ? "bg-danger text-white" :
                          value === 3 ? "bg-yellow-300 !text-black" :
                            value === 4 ? "bg-orange-500 text-white" :
                              "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md inline-block !cursor-pointer`}
                    >
                      {loadingId === row?._id ? (
                        <Spinner color="default" key={row._id} size="sm" />
                      ) : (
                        <>
                          {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Pending" : value === 4 ? "Duplicate" : "N/A"}
                        </>
                      )}
                    </div>
                  );

                case "pushed_to_simple": {
                  const pVal = rowState.pushed_to_simple ?? value;
                  const isSuccess = pVal === 1;
                  const isFailed = pVal === 3;
                  const isPending = pVal === 2 || pVal === 0;
                  const isDuplicate = pVal === 4;

                  return (
                    <div
                      className={`${isSuccess ? "bg-accepted text-white" :
                        isPending ? "bg-yellow-300 !text-black" :
                          isFailed ? "bg-danger text-white" :
                            isDuplicate ? "bg-orange-500 text-white" :
                              "bg-white !text-black"
                        } py-1 px-3 rounded-global shadow-md inline-block text-xs font-semibold`}
                    >
                      {isSuccess ? "Success" : isPending ? "Pending" : isFailed ? "Failed" : isDuplicate ? "Duplicate" : "N/A"}
                    </div>
                  );
                }

                case "simple_pincode_verified": {
                  const isVerified = (rowState.simple_pincode_verified ?? value) === 1;
                  return (
                    <div
                      className={`${isVerified ? "bg-accepted text-white" : "bg-danger text-white"} py-1 px-3 rounded-global shadow-md text-xs font-semibold inline-block`}
                    >
                      {isVerified ? "Verified" : "Unverified"}
                    </div>
                  );
                }

                case "simple_call_verification": {
                  const callVal = rowState.simple_call_verification ?? value ?? 0;
                  const labelMap = { 1: "Interested", 2: "Not Interested", 3: "Schedule", 0: "Pending" };

                  return (
                    <div className="inline-block min-w-[135px]">
                      {isUpdatingCall ? (
                        <Spinner size="sm" color="default" />
                      ) : (leadType === 'Simple' && hasSendPermission) ? (
                        <div className="relative inline-flex items-center">
                          <select
                            value={callVal || 0}
                            onChange={(e) => handleUpdateCallVerification(e.target.value)}
                            className={`appearance-none text-xs font-semibold py-1.5 pl-3.5 pr-7 rounded-global shadow-md outline-none cursor-pointer transition-all duration-200 border-0 ${
                              callVal === 1
                                ? "bg-accepted text-white hover:brightness-105"
                                : callVal === 2
                                ? "bg-danger text-white hover:brightness-105"
                                : callVal === 3
                                ? "bg-[#2563eb] text-white hover:brightness-105"
                                : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
                            }`}
                          >
                            {(!callVal || callVal === 0) && (
                              <option value={0} className="bg-white text-gray-800 py-1">Pending</option>
                            )}
                            <option value={1} className="bg-white text-green-700 py-1 font-semibold">Interested</option>
                            <option value={2} className="bg-white text-red-600 py-1 font-semibold">Not Interested</option>
                            <option value={3} className="bg-white text-blue-600 py-1 font-semibold">Schedule</option>
                          </select>
                          <div className={`pointer-events-none absolute right-2 flex items-center ${callVal === 0 ? "text-gray-500" : "text-white"}`}>
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <span
                          className={`py-1.5 px-3.5 rounded-global text-xs font-semibold text-white inline-block shadow-md ${
                            callVal === 1
                              ? "bg-accepted"
                              : callVal === 2
                              ? "bg-danger"
                              : callVal === 3
                              ? "bg-[#2563eb]"
                              : "bg-gray-400"
                          }`}
                        >
                          {labelMap[callVal] || "Pending"}
                        </span>
                      )}
                    </div>
                  );
                }

                case "simple_selected_model_id": {
                  const selectedId = rowState.simple_selected_model_id ?? value ?? "";
                  const selectedLabel = rowState.simple_selected_model || "";
                  const isSent = rowState.pushed_to_simple === 1;

                  if (isUpdatingVehicle) {
                    return <Spinner size="sm" color="default" />;
                  }

                  // Read-only text for users without send permission or after the lead is sent
                  if (!(leadType === 'Simple' && hasSendPermission) || isSent) {
                    return (
                      <span className={`text-xs font-semibold ${selectedLabel ? "text-gray-800" : "text-gray-400"}`}>
                        {selectedLabel || (isSent ? "-" : "Auto")}
                      </span>
                    );
                  }

                  const modelList = Array.isArray(simpleVariants) ? simpleVariants : [];
                  const hasSelectedInList = modelList.some(m => m.modelId === selectedId);

                  return (
                    <div className="relative inline-flex items-center min-w-[170px]">
                      <select
                        value={selectedId || ""}
                        onChange={(e) => handleUpdateVehicle(e.target.value)}
                        className={`appearance-none w-full text-xs font-semibold py-1.5 pl-3.5 pr-7 rounded-global shadow-md outline-none cursor-pointer transition-all duration-200 ${
                          selectedId
                            ? "bg-[#487192] text-white border-0 hover:brightness-105"
                            : "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
                        }`}
                      >
                        <option value="" className="bg-white text-gray-800">Auto (Random)</option>
                        {selectedId && !hasSelectedInList && (
                          <option value={selectedId} className="bg-white text-gray-800">{selectedLabel || selectedId}</option>
                        )}
                        {modelList.map((m) => (
                          <option key={m.modelId} value={m.modelId} className="bg-white text-gray-800">
                            {m.modelName}
                          </option>
                        ))}
                      </select>
                      <div className={`pointer-events-none absolute right-2 flex items-center ${selectedId ? "text-white" : "text-gray-500"}`}>
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </div>
                  );
                }

                case "pincode": {
                  const pinText = (value === null || value === undefined || value === "") ? "-" : String(value);
                  if (leadType !== 'Simple') return pinText;

                  const canEditPincode = hasSendPermission && rowState.pushed_to_simple !== 1 && rowState.simple_verification !== 1;
                  const pinHistory = Array.isArray(rowState.simple_pincode_history) ? rowState.simple_pincode_history : [];

                  if (isEditingPincode) {
                    return (
                      <div className="inline-flex items-center gap-1.5">
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          autoFocus
                          value={pincodeInput}
                          disabled={isSavingPincode}
                          onChange={(e) => setPincodeInput(e.target.value.replace(/\D/g, "").slice(0, 6))}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleSavePincode();
                            if (e.key === "Escape") cancelPincodeEdit();
                          }}
                          className="w-[88px] text-xs font-mono font-semibold px-2 py-1 rounded-md border border-gray-300 outline-none focus:border-[#487192] bg-white"
                        />
                        {isSavingPincode ? (
                          <Spinner size="sm" color="default" />
                        ) : (
                          <>
                            <button
                              type="button"
                              title="Save pincode"
                              onClick={handleSavePincode}
                              className="w-6 h-6 rounded-md flex items-center justify-center bg-accepted text-white hover:brightness-105 cursor-pointer"
                            >
                              <FiCheck className="text-sm" />
                            </button>
                            <button
                              type="button"
                              title="Cancel"
                              onClick={cancelPincodeEdit}
                              className="w-6 h-6 rounded-md flex items-center justify-center bg-danger text-white hover:brightness-105 cursor-pointer"
                            >
                              <FiX className="text-sm" />
                            </button>
                          </>
                        )}
                      </div>
                    );
                  }

                  return (
                    <div className="inline-flex items-center gap-1.5">
                      <span>{pinText}</span>
                      {canEditPincode && (
                        <button
                          type="button"
                          title="Edit pincode"
                          onClick={startPincodeEdit}
                          className="text-gray-400 hover:text-[#487192] cursor-pointer"
                        >
                          <FiEdit2 className="text-xs" />
                        </button>
                      )}
                      {pinHistory.length > 0 && (
                        <button
                          type="button"
                          title="View pincode change history"
                          onClick={() => HandleLeadDetails(row._id, "simple_pincode_history")}
                          className="text-gray-400 hover:text-[#487192] cursor-pointer"
                        >
                          <FiClock className="text-xs" />
                        </button>
                      )}
                    </div>
                  );
                }

                case "simple_history": {
                  const historyList = Array.isArray(value) ? value : (value && typeof value === 'object' ? [value] : []);
                  if (!historyList || historyList.length === 0) {
                    return <span className="text-gray-400 font-medium">-</span>;
                  }
                  const latest = historyList[historyList.length - 1];
                  const latestStatus = latest?.status || (latest?.simple_verification === 1 ? "Accepted" : latest?.simple_verification === 2 ? "Rejected" : "View");
                  const latestMsg = typeof latest?.message === "object" ? (latest?.message?.message || latest?.message?.error || JSON.stringify(latest.message)) : (latest?.message || "");
                  const isAccepted = latestStatus === "Accepted" || latestStatus === "Success" || latestStatus === 1;
                  const isRejected = latestStatus === "Rejected" || latestStatus === "Failed" || latestStatus === 2;

                  return (
                    <div
                      onClick={() => HandleLeadDetails(row._id, "simple_history")}
                      className="inline-flex items-center gap-1.5 cursor-pointer max-w-[280px] group"
                      title={`${latestStatus}: ${latestMsg}\nClick to view full history`}
                    >
                      <span
                        className={`py-0.5 px-2 text-xs rounded-global font-semibold text-white shadow-sm shrink-0 ${
                          isAccepted
                            ? "bg-accepted"
                            : isRejected
                            ? "bg-danger"
                            : "bg-gray-500"
                        }`}
                      >
                        {String(latestStatus)}
                      </span>
                      {latestMsg && (
                        <span className="text-xs text-gray-700 truncate group-hover:underline">
                          {latestMsg}
                        </span>
                      )}
                    </div>
                  );
                }

                default: {
                  if (value === null || value === undefined || value === "") return "-";
                  if (Array.isArray(value)) {
                    if (value.length === 0) return "-";
                    const first = value[0];
                    if (typeof first === "object" && first !== null) {
                      const latest = value[value.length - 1];
                      const statusText = latest?.status || latest?.message || `View (${value.length})`;
                      return (
                        <span
                          className="cursor-pointer text-primary hover:underline text-xs"
                          onClick={() => HandleLeadDetails && HandleLeadDetails(row._id, col.uid)}
                        >
                          {typeof statusText === "object" ? JSON.stringify(statusText) : String(statusText)}
                        </span>
                      );
                    }
                    return value.join(", ");
                  }
                  if (typeof value === "object") {
                    return JSON.stringify(value);
                  }
                  return String(value);
                }
              }
            })()}
          </TableCell>
        ))}

      </TableRow>

      {/* Collapsible Row for History */}
      <TableRow id={`left-collapse-row-${row._id}`} className={`${isFetchingleadDetails ? 'bg-[#e5f3fb]' : 'bg-[#f9f9f9]'}`}>
        <TableCell style={{ padding: '0px', margin: '0px' }} colSpan={columns.length + 2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {isFetchingleadDetails ? (
              <div className="px-6 py-4 border-t !bg-[#e5f3fb] flex gap-2 flex-col">
                <Skeleton className="w-full h-[25px] p-2 px-4 !bg-gray-100" />
                <div className="flex gap-4">
                  <Skeleton className="w-full h-30px] p-2 px-4  !bg-gray-100" />
                  <Skeleton className="w-full h-[30px] p-2 px-4  !bg-gray-100" />
                </div>
                <Skeleton className="w-full h-[35px] p-2 px-4  !bg-gray-100" />
                <Skeleton className="w-full h-[35px] p-2 px-4  !bg-gray-100" />
                <Skeleton className="w-full h-[35px] p-2 px-4  !bg-gray-100" />
                <Skeleton className="w-full h-[35px] p-2 px-4  !bg-gray-100" />
              </div>
            ) : (
              <div className="px-6 py-4 border-t border-gray-200">
                <p className="font-bold mb-2 text-large">{row.name} Lead Journey:</p>
                {leadDetailsMap?.[row._id]?.length > 0 ? (
                  <Table aria-label="collapsible table">
                    <TableHead className="bg-gray-100 text-left">
                      <TableRow>
                        <TableCell className="!py-1 !px-4 border-b !text-medium">Date</TableCell>
                        <TableCell className="!py-1 !px-4 border-b !text-medium">Update</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {leadDetailsMap[row._id].map((entry, idx) => (
                        <TableRow key={idx} className="hover:bg-gray-50">
                          <TableCell className="!py-2 px-4 border-b text-gray-700 text-nowrap">{formatDate(entry.date)}</TableCell>
                          <TableCell className="!py-2 px-4 border-b text-gray-800">{entry.update}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <p className="text-gray-500">No Journey available.</p>
                )}
              </div>
            )}

          </Collapse>
        </TableCell>
      </TableRow>

    </>
  );
}

function LeadData({ allLeadsData, getGoogleSignedRecordingUrl, columns, selectedColumns, setPageLimit, pageLimit = '10', getAllLeads, leadType, getleadDetails, getleadViewDetails, fetchOEMHistory, debouncedSearch, apiType, filter }) {
  // Fetch OEM Hisotry
  const { oemHistory, historyLoading, histroyError, user, permissionsFlag } = useAuth();
  const hasSendPermission = Boolean(user?.type === 'SUPER' || (Array.isArray(permissionsFlag) && permissionsFlag.some((p) => p?.key === 'SIMPLE_LEAD_SEND' || p?.key === 'SUPER_ADMIN')));
  const showSendLeadColumn = leadType === 'Simple' && hasSendPermission;

  // Split-layout refs and reactive states for SEND LEAD column in remaining space
  const leftScrollRef = useRef(null);
  const rightScrollRef = useRef(null);
  const tableBodyRef = useRef(null);
  const [rowHeights, setRowHeights] = useState({});
  const [headerHeight, setHeaderHeight] = useState(52);
  const [openRows, setOpenRows] = useState({});
  const [selectedLeadForSend, setSelectedLeadForSend] = useState(null);
  const [leadsState, setLeadsState] = useState({});
  const [simpleVariants, setSimpleVariants] = useState([]);

  // Load Simple Energy vehicles once per table (not per row) for the vehicle dropdown
  useEffect(() => {
    if (!showSendLeadColumn) return;
    let cancelled = false;
    axios.get(`${process.env.REACT_APP_API_URL}api/simple-leads/vehicle-variants`)
      .then((res) => {
        if (cancelled) return;
        if (res.data?.success && Array.isArray(res.data.result)) {
          setSimpleVariants(res.data.result);
        } else if (res.data?.message) {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        if (!cancelled) toast.error('Failed to load Simple Energy vehicles');
      });
    return () => { cancelled = true; };
  }, [showSendLeadColumn]);

  const [loadingId, setLoadingId] = useState(null);
  const [loadingRecordingById, setLoadingRecordingById] = useState(null);
  const [recordingUrls, setRecordingUrls] = useState({});
  const [noRecordingIds, setNoRecordingIds] = useState({});

  const [leadData, setLeadData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [leadDetails, setLeadDetails] = useState([]);
  const [isfetching, setIsfetching] = useState(false);
  const [openLeadView, setOpenLeadView] = useState(false);
  const [leadDetailsMap, setLeadDetailsMap] = useState({});
  const [isFetchingleadDetails, setIsFetchingleadDetails] = useState(false);
  const [queries, setQueries] = useState({
    search: '',
    limit: pageLimit,
    page: 1,
    totalDocs: 0,
    totalPages: 0
  })

  const isFirstRender = useRef(true);

  // handel pageLimit
  const handlePageChange = (selectedPage) => {
    setQueries((prev) => {
      if (prev.page !== selectedPage) {
        return { ...prev, page: selectedPage };
      }
      return prev; // Prevent unnecessary updates
    });
    setCurrentPage(selectedPage);

    // Explicitly fetch leads if switching back to page 1
    if (selectedPage === 1) {
      const bodyObj = { page: 1, limit: pageLimit, search: debouncedSearch, company: leadType }
      Object.keys(filter).forEach((key) => {
        const rawFormattedKey = key.replace(/\s+/g, "_").toLowerCase();
        const formattedKey = rawFormattedKey === 'battery_wise_exploration' ? 'batteryWiseExploration' : rawFormattedKey;
        if (formattedKey === 'simple_sent_by_inc_date') {
          if (filter[key]?.startDate && filter[key]?.endDate) {
            bodyObj.simple_sent_start_date = new Date(filter[key].startDate).toISOString();
            bodyObj.simple_sent_end_date = new Date(filter[key].endDate).toISOString();
          }
          return;
        }
        if (formattedKey.endsWith('_inc_date')) return;
        if (key === 'date' && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.startDate = new Date(filter[key].startDate).toISOString();
          bodyObj.endDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'ola_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.ola_addon_startdate = new Date(filter[key].startDate).toISOString();
          bodyObj.ola_addon_enddate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'ola_order_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.orderedStartDate = new Date(filter[key].startDate).toISOString();
          bodyObj.orderedEndDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'filter_by_updated_at' && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.updateStartDate = new Date(filter[key].startDate).toISOString();
          bodyObj.updateEndDate = new Date(filter[key].endDate).toISOString();
        }
        else if ((formattedKey === 'retaildate' || formattedKey === 'tvs_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.tvs_start_retailDate = new Date(filter[key].startDate).toISOString();
          bodyObj.tvs_end_retailDate = new Date(filter[key].endDate).toISOString();
        }
        else if ((formattedKey === 'retaildate' || formattedKey === 'ola_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.ola_start_retailDate = new Date(filter[key].startDate).toISOString();
          bodyObj.ola_end_retailDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
          bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
        }
        else if ((formattedKey === 'retaildate' || formattedKey === 'revolt_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.revolt_start_retailDate = new Date(filter[key].startDate).toISOString();
          bodyObj.revolt_end_retailDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'revolt_booking_date' && filter[key]?.startDate) {
          bodyObj.revolt_start_bookingDate = new Date(filter[key].startDate).toISOString();
          if (filter[key]?.endDate) bodyObj.revolt_end_bookingDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'revolt_tr_completed_date' && filter[key]?.startDate) {
          bodyObj.revolt_start_trCompletedDate = new Date(filter[key].startDate).toISOString();
          if (filter[key]?.endDate) bodyObj.revolt_end_trCompletedDate = new Date(filter[key].endDate).toISOString();
        }
        else if (formattedKey === 'revolt_tr_scheduled_date' && filter[key]?.startDate) {
          bodyObj.revolt_start_trScheduledDate = new Date(filter[key].startDate).toISOString();
          if (filter[key]?.endDate) bodyObj.revolt_end_trScheduledDate = new Date(filter[key].endDate).toISOString();
        }
        else if (Array.isArray(filter[key]) && filter[key].length > 0) {
          bodyObj[formattedKey] = filter[key].toString();
        }
        else if (filter[key] !== null && filter[key] !== undefined) {
          bodyObj[formattedKey] = filter[key];
        }
      });
      // Addon date ranges
      const dateRanges = [];
      for (const key in filter) {
        if (key.endsWith('_inc_date') && key !== 'simple_sent_by_inc_date') {
          const range = filter[key];
          if (range?.startDate && range?.endDate) {
            dateRanges.push(range);
          }
        }
      }
      if (dateRanges.length > 1) {
        bodyObj.isHistoric = true;
        const timestamps = dateRanges.map((range) => ({
          start: new Date(range.startDate).getTime(),
          end: new Date(range.endDate).getTime(),
        }));

        const minStart = Math.min(...timestamps.map((d) => d.start));
        const maxEnd = Math.max(...timestamps.map((d) => d.end));

        // Total duration of range in ms
        const duration = maxEnd - minStart;

        // Compute new mid-range (preserving original time format)
        const midStart = new Date(minStart + duration / 4); // shift to 25% into the period
        const midEnd = new Date(minStart + (3 * duration) / 4); // shift to 75% into the period

        // Normalize to fixed time format
        midStart.setUTCHours(18, 30, 0, 0); // 00:00 IST
        midEnd.setUTCHours(18, 29, 59, 999); // 11:59:59 IST

        bodyObj.updatedAtStartDate = midStart.toISOString();
        bodyObj.updatedAtEndDate = midEnd.toISOString();
      } else if (dateRanges.length === 1) {
        bodyObj.isHistoric = true;
        bodyObj.updatedAtStartDate = dateRanges[0].startDate;
        bodyObj.updatedAtEndDate = dateRanges[0].endDate;
      }
      // Over

      getAllLeads(bodyObj);
    }
  };

  // Fetch Leads on Page or Limit Change
  useEffect(() => {
    const bodyObj = { page: queries.page, limit: queries.limit, search: debouncedSearch, company: leadType }
    Object.keys(filter).forEach((key) => {
      const rawFormattedKey = key.replace(/\s+/g, "_").toLowerCase();
      const formattedKey = rawFormattedKey === 'battery_wise_exploration' ? 'batteryWiseExploration' : rawFormattedKey;
      if (formattedKey === 'simple_sent_by_inc_date') {
        if (filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.simple_sent_start_date = new Date(filter[key].startDate).toISOString();
          bodyObj.simple_sent_end_date = new Date(filter[key].endDate).toISOString();
        }
        return;
      }
      if (formattedKey.endsWith('_inc_date')) return;
      if (key === 'date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.startDate = new Date(filter[key].startDate).toISOString();
        bodyObj.endDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_addon_startdate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_addon_enddate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_order_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.orderedStartDate = new Date(filter[key].startDate).toISOString();
        bodyObj.orderedEndDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'filter_by_updated_at' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.updateStartDate = new Date(filter[key].startDate).toISOString();
        bodyObj.updateEndDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'tvs_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.tvs_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.tvs_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'ola_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'revolt_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.revolt_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.revolt_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_booking_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_bookingDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_bookingDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_tr_completed_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_trCompletedDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_trCompletedDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_tr_scheduled_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_trScheduledDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_trScheduledDate = new Date(filter[key].endDate).toISOString();
      }
      else if (Array.isArray(filter[key]) && filter[key].length > 0) {
        bodyObj[formattedKey] = filter[key].toString();
      }
      else if (filter[key] !== null && filter[key] !== undefined) {
        bodyObj[formattedKey] = filter[key];
      }
    });
    // Addon date ranges
    const dateRanges = [];
    for (const key in filter) {
      if (key.endsWith('_inc_date') && key !== 'simple_sent_by_inc_date') {
        const range = filter[key];
        if (range?.startDate && range?.endDate) {
          dateRanges.push(range);
        }
      }
    }
    if (dateRanges.length > 1) {
      bodyObj.isHistoric = true;
      const timestamps = dateRanges.map((range) => ({
        start: new Date(range.startDate).getTime(),
        end: new Date(range.endDate).getTime(),
      }));

      const minStart = Math.min(...timestamps.map((d) => d.start));
      const maxEnd = Math.max(...timestamps.map((d) => d.end));

      // Total duration of range in ms
      const duration = maxEnd - minStart;

      // Compute new mid-range (preserving original time format)
      const midStart = new Date(minStart + duration / 4); // shift to 25% into the period
      const midEnd = new Date(minStart + (3 * duration) / 4); // shift to 75% into the period

      // Normalize to fixed time format
      midStart.setUTCHours(18, 30, 0, 0); // 00:00 IST
      midEnd.setUTCHours(18, 29, 59, 999); // 11:59:59 IST

      bodyObj.updatedAtStartDate = midStart.toISOString();
      bodyObj.updatedAtEndDate = midEnd.toISOString();
    } else if (dateRanges.length === 1) {
      bodyObj.isHistoric = true;
      bodyObj.updatedAtStartDate = dateRanges[0].startDate;
      bodyObj.updatedAtEndDate = dateRanges[0].endDate;
    }
    // Over
    if (!isFirstRender.current) {
      getAllLeads(bodyObj);
    } else {
      isFirstRender.current = false; // Prevent first render API call
    }
  }, [queries.page, queries.limit]); // Ensure it runs on page and limit change


  useEffect(() => {
    if (allLeadsData?.totalPages) {
      setQueries((prev) => ({ ...prev, totalPages: allLeadsData.totalPages }));
    }
  }, [allLeadsData]);

  useEffect(() => {
    if (allLeadsData?.page !== queries.page) {
      setCurrentPage(allLeadsData.page || 1);
    }
  }, [allLeadsData]);

  const filteredColumns = columns.filter((col) => selectedColumns.includes(col.uid) && !["_id", "flag", "actions"].includes(col.uid));

  const currentRows = allLeadsData?.docs || [];
  const totalPages = allLeadsData?.totalPages || 1;

  // Page Limit Change
  const onPageClick = (page, limit) => {
    setCurrentPage(page); // Ensure the UI updates immediately
    setQueries((prev) => ({ ...prev, page, limit }));
    const bodyObj = { page: page, limit: limit, search: debouncedSearch, company: leadType }
    Object.keys(filter).forEach((key) => {
      const rawFormattedKey = key.replace(/\s+/g, "_").toLowerCase();
      const formattedKey = rawFormattedKey === 'battery_wise_exploration' ? 'batteryWiseExploration' : rawFormattedKey;
      if (formattedKey === 'simple_sent_by_inc_date') {
        if (filter[key]?.startDate && filter[key]?.endDate) {
          bodyObj.simple_sent_start_date = new Date(filter[key].startDate).toISOString();
          bodyObj.simple_sent_end_date = new Date(filter[key].endDate).toISOString();
        }
        return;
      }
      if (formattedKey.endsWith('_inc_date')) return;
      if (key === 'date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.startDate = new Date(filter[key].startDate).toISOString();
        bodyObj.endDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_addon_startdate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_addon_enddate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_order_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.orderedStartDate = new Date(filter[key].startDate).toISOString();
        bodyObj.orderedEndDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'filter_by_updated_at' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.updateStartDate = new Date(filter[key].startDate).toISOString();
        bodyObj.updateEndDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'tvs_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.tvs_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.tvs_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'ola_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
        bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
      }
      else if ((formattedKey === 'retaildate' || formattedKey === 'revolt_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
        bodyObj.revolt_start_retailDate = new Date(filter[key].startDate).toISOString();
        bodyObj.revolt_end_retailDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_booking_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_bookingDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_bookingDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_tr_completed_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_trCompletedDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_trCompletedDate = new Date(filter[key].endDate).toISOString();
      }
      else if (formattedKey === 'revolt_tr_scheduled_date' && filter[key]?.startDate) {
        bodyObj.revolt_start_trScheduledDate = new Date(filter[key].startDate).toISOString();
        if (filter[key]?.endDate) bodyObj.revolt_end_trScheduledDate = new Date(filter[key].endDate).toISOString();
      }
      else if (Array.isArray(filter[key]) && filter[key].length > 0) {
        bodyObj[formattedKey] = filter[key].toString();
      }
      else if (filter[key] !== null && filter[key] !== undefined) {
        bodyObj[formattedKey] = filter[key];
      }
    });
    // Addon date ranges
    const dateRanges = [];
    for (const key in filter) {
      if (key.endsWith('_inc_date') && key !== 'simple_sent_by_inc_date') {
        const range = filter[key];
        if (range?.startDate && range?.endDate) {
          dateRanges.push(range);
        }
      }
    }
    if (dateRanges.length > 1) {
      bodyObj.isHistoric = true;
      const timestamps = dateRanges.map((range) => ({
        start: new Date(range.startDate).getTime(),
        end: new Date(range.endDate).getTime(),
      }));

      const minStart = Math.min(...timestamps.map((d) => d.start));
      const maxEnd = Math.max(...timestamps.map((d) => d.end));

      // Total duration of range in ms
      const duration = maxEnd - minStart;

      // Compute new mid-range (preserving original time format)
      const midStart = new Date(minStart + duration / 4); // shift to 25% into the period
      const midEnd = new Date(minStart + (3 * duration) / 4); // shift to 75% into the period

      // Normalize to fixed time format
      midStart.setUTCHours(18, 30, 0, 0); // 00:00 IST
      midEnd.setUTCHours(18, 29, 59, 999); // 11:59:59 IST

      bodyObj.updatedAtStartDate = midStart.toISOString();
      bodyObj.updatedAtEndDate = midEnd.toISOString();
    } else if (dateRanges.length === 1) {
      bodyObj.isHistoric = true;
      bodyObj.updatedAtStartDate = dateRanges[0].startDate;
      bodyObj.updatedAtEndDate = dateRanges[0].endDate;
    }
    // Over

    getAllLeads(bodyObj);
  };


  // Handle Lead History
  const HandleLeadDetails = (id, tag) => {
    setLoadingId(id);
    const historyFields = {
      ola: ['ola_history', 'ola_status_history'],
      tvs: ['tvs_history'],
      revolt: ['revolt_history', 'revolt_status_history'],
      ampere: ['ampere_history'],
      tvs_status_history: ['tvs_status_history'],
      simple: ['simple_history', 'simple_pincode_history'],
    };

    const oemType = Object.keys(historyFields).find((key) =>
      historyFields[key].includes(tag)
    );

    if (!oemType) {
      toast.error(`OEM type not found for tag: ${tag}`);
      setLoadingId(null);
      return;
    }

    const titleFormatted = tag
      .replace(/_/g, " ")
      .replace(/\bHistory\b/gi, "")
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

    fetchOEMHistory(id, oemType)
      .then((res) => {
        const data = res?.data?.result || {};
        const historyArray = data?.[tag] || [];
        // If API response is empty, check if row data already has history
        if ((!historyArray || historyArray.length === 0) && currentRows) {
          const rowData = currentRows.find((r) => r._id === id);
          if (rowData && Array.isArray(rowData[tag]) && rowData[tag].length > 0) {
            setLeadData(rowData[tag]);
            setModalTitle(titleFormatted);
            setIsModalOpen(true);
            return;
          }
        }
        setLeadData(historyArray);
        setModalTitle(titleFormatted);
        setIsModalOpen(true);
      })
      .catch((err) => {
        // Fallback to row data if API fails
        if (currentRows) {
          const rowData = currentRows.find((r) => r._id === id);
          if (rowData && Array.isArray(rowData[tag])) {
            setLeadData(rowData[tag]);
            setModalTitle(titleFormatted);
            setIsModalOpen(true);
            return;
          }
        }
        toast.error(err?.response?.data?.error || err?.response?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setLoadingId(null); // Done loading for this row
      });
  };

  // Handle get Lead Details
  const handleGetLeadDetails = (id) => {
    setOpenLeadView(true);
    setIsfetching(true);
    if (leadType === 'Dialshree' || leadType === 'Dialshreeinbound') {
      apiType = 'dialshree/';
    } else {
      apiType = 'leads/getLeadHistory/';
    }
    getleadViewDetails(id, apiType).then((res) => {
      setLeadDetails(res.data.result);
      setTimeout(() => {
        setIsfetching(false);
      }, 2000);
    });
  }

  const handleGetRecordingUrl = (id) => {
    setLoadingRecordingById(id);
    getGoogleSignedRecordingUrl(id)
      .then((res) => {
        const url = res?.data;
        if (url) {
          setRecordingUrls((prev) => ({ ...prev, [id]: url }));
          toast.success(res?.message || "Recording URL fetched successfully!");
        } else {
          toast.error("No recording URL found for this lead.");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error.message);
      })
      .finally(() => {
        setLoadingRecordingById(null); // Reset loading state after fetching
      });
  };

  useEffect(() => {
    if (currentRows && currentRows.length > 0) {
      const initialState = {};
      currentRows.forEach((r) => {
        initialState[r._id] = r;
      });
      setLeadsState(initialState);
    }
  }, [currentRows]);

  const updateLeadState = (leadId, updates) => {
    setLeadsState((prev) => ({
      ...prev,
      [leadId]: { ...(prev[leadId] || {}), ...updates },
    }));
  };

  const handleToggleAccordion = (id, isOpen) => {
    setOpenRows((prev) => ({ ...prev, [id]: isOpen }));
  };

  const handleLeftScroll = (e) => {
    if (rightScrollRef.current) {
      rightScrollRef.current.scrollTop = e.target.scrollTop;
    }
  };

  const handleRightScroll = (e) => {
    if (leftScrollRef.current) {
      leftScrollRef.current.scrollTop = e.target.scrollTop;
    }
  };

  const handleRightWheel = (e) => {
    if (leftScrollRef.current) {
      leftScrollRef.current.scrollTop += e.deltaY;
    }
  };

  useEffect(() => {
    if (!tableBodyRef.current || !showSendLeadColumn) return;

    const measureHeights = () => {
      const heights = {};
      currentRows?.forEach((row) => {
        const mainEl = document.getElementById(`left-main-row-${row._id}`);
        const collapseEl = document.getElementById(`left-collapse-row-${row._id}`);
        let totalH = 58;
        if (mainEl) {
          totalH = mainEl.offsetHeight;
        }
        if (collapseEl && openRows[row._id]) {
          totalH += collapseEl.offsetHeight;
        }
        heights[row._id] = totalH;
      });
      setRowHeights(heights);

      const headEl = document.getElementById('left-table-header');
      if (headEl) {
        setHeaderHeight(headEl.offsetHeight);
      }
    };

    measureHeights();

    const observer = new ResizeObserver(() => {
      measureHeights();
    });

    observer.observe(tableBodyRef.current);
    return () => observer.disconnect();
  }, [currentRows, openRows, showSendLeadColumn]);

  // Handle accordion leads data 
  const handleVIewLeadDetailsInaccordion = (id) => {
    setIsFetchingleadDetails(true);
    getleadDetails(id).then((res) => {
      setLeadDetailsMap(prev => ({
        ...prev,
        [id]: res.data.result
      }));
      setTimeout(() => {
        setIsFetchingleadDetails(false);
      }, 2000);
    });
  };

  return (
    <>
      {(currentRows && currentRows.length > 0) ? (
        <>
          <Box className="shadow-none px-4 py-6 rounded-outSideglobal w-full default-scrollbar h-full overflow-hidden">
            {showSendLeadColumn ? (
              /* Two-Column Layout: Table (Red Box) + Action Buttons Outside Table (No SEND LEAD heading) */
              selectedColumns.length > 0 ? (
                <div className="h-[calc(100%-68px)] flex flex-row gap-3 w-full">
                  {/* Left Section (Red Box in screenshot): The Standalone Scrollable Table */}
                  <TableContainer
                    ref={leftScrollRef}
                    onScroll={handleLeftScroll}
                    component={Paper}
                    className="flex-1 min-w-0 h-full p-5 !pt-7 roundedOutSideglobal overflow-x-auto overflow-y-auto shadow-global default-scrollbar !bg-[#e5f3fb] border border-black/10"
                  >
                    <Table aria-label="collapsible table">
                      <TableHead className="rounded-outSideglobal shadow-global table-shadow-specific !sticky top-0 !bg-[#e5f3fb] z-10">
                        <TableRow id="left-table-header" className="border-none removed-border">
                          <TableCell align="left" className="border-none removed-border flex" />
                          <TableCell key={"No"} align="left" className="border-none removed-border">No</TableCell>
                          {filteredColumns.map((col) => (
                            <TableCell key={col.uid} align="left" className="border-none removed-border whitespace-nowrap">
                              {col.name}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody ref={tableBodyRef} className="border-none removed-border w-full text-center">
                        {currentRows?.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={filteredColumns.length + 2} align="center">
                              No rows to display.
                            </TableCell>
                          </TableRow>
                        ) : (
                          currentRows?.map((row, index) => (
                            <Row
                              key={row.id || row._id}
                              row={leadsState[row._id] || row}
                              columns={filteredColumns}
                              index={index}
                              currentPage={currentPage}
                              HandleLeadDetails={HandleLeadDetails}
                              pageLimit={parseInt(pageLimit, 10)}
                              leadType={leadType}
                              handleGetLeadDetails={handleGetLeadDetails}
                              handleVIewLeadDetailsInaccordion={handleVIewLeadDetailsInaccordion}
                              isFetchingleadDetails={isFetchingleadDetails}
                              leadDetailsMap={leadDetailsMap}
                              loadingId={loadingId}
                              handleGetRecordingUrl={handleGetRecordingUrl}
                              recordingUrls={recordingUrls}
                              loadingRecordingById={loadingRecordingById}
                              noRecordingIds={noRecordingIds}
                              onUpdateLeadState={updateLeadState}
                              onToggleAccordion={handleToggleAccordion}
                              simpleVariants={simpleVariants}
                            />
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Right Section: Action Buttons Outside Table with Heading & Fixed Sizes */}
                  <div
                    className="w-[145px] min-w-[145px] max-w-[145px] h-full flex flex-col flex-shrink-0 bg-[#e5f3fb] roundedOutSideglobal shadow-global border border-black/10 pt-7 pb-5 px-3"
                  >
                    {/* Heading matching table header height and styling */}
                    <div
                      style={{ height: headerHeight ? `${headerHeight}px` : '52px' }}
                      className="w-full bg-[#487192] text-white font-bold text-xs flex items-center justify-center rounded-outSideglobal shadow-md tracking-wider flex-shrink-0 select-none"
                    >
                      SEND LEAD
                    </div>

                    {/* Scrollable list of Action Buttons synced with Table */}
                    <div
                      ref={rightScrollRef}
                      onScroll={handleRightScroll}
                      onWheel={handleRightWheel}
                      className="flex-1 w-full overflow-y-hidden overflow-x-hidden default-scrollbar mt-1"
                    >
                      {currentRows?.map((row) => {
                        const lead = leadsState[row._id] || row;
                        const isOpen = openRows[row._id];
                        const rowHeight = rowHeights[row._id] || (isOpen ? 120 : 58);

                        const renderAction = () => {
                          // 1. Sent Successfully (pushed_to_simple === 1) -> Display Sent text
                          if (lead.pushed_to_simple === 1) {
                            return (
                              <span className="text-accepted font-bold text-xs inline-flex items-center gap-1 select-none">
                                <IoCheckmark className="text-sm stroke-[3]" /> Sent
                              </span>
                            );
                          }

                          // 2. Failed button only when the push itself Failed / was Rejected by Simple (pushed_to_simple === 3 or simple_verification === 2)
                          if (lead.pushed_to_simple === 3 || lead.simple_verification === 2) {
                            return (
                              <button
                                type="button"
                                onClick={() => setSelectedLeadForSend(lead)}
                                title="Rejected / Failed - Click to retry"
                                className="bg-danger hover:bg-red-700 text-white px-3.5 py-1.5 rounded-[10px] text-xs font-semibold inline-flex items-center justify-center gap-1.5 shadow-sm transition-all duration-150 active:scale-95 cursor-pointer"
                              >
                                <FiAlertCircle className="text-xs" /> Failed
                              </button>
                            );
                          }

                          // Duplicate of an already existing Simple lead -> can never be sent
                          if (lead.pushed_to_simple === 4 || lead.simple_verification === 4) {
                            return (
                              <span
                                title="This number already exists for Simple Energy"
                                className="bg-orange-500 text-white px-3.5 py-1.5 rounded-[10px] text-xs font-semibold inline-flex items-center justify-center select-none cursor-not-allowed"
                              >
                                Duplicate
                              </span>
                            );
                          }

                          // Call center marked Not Interested -> show nothing in this column
                          if (lead.simple_call_verification === 2) {
                            return null;
                          }

                          // 3. Pending (pushed_to_simple is 2 or 0) -> Display Send Lead button only if simple_pincode_verified === 1
                          if (lead.pushed_to_simple === 2 || lead.pushed_to_simple === 0) {
                            if (lead.simple_pincode_verified === 1) {
                              return (
                                <button
                                  type="button"
                                  onClick={() => setSelectedLeadForSend(lead)}
                                  className="bg-[#487192] hover:bg-[#385873] text-white px-3.5 py-1.5 rounded-[10px] text-xs font-semibold inline-flex items-center justify-center gap-1.5 shadow-sm transition-all duration-150 active:scale-95 cursor-pointer"
                                >
                                  <FiSend className="text-xs" /> Send Lead
                                </button>
                              );
                            }

                            // If pincode is not verified, do not display the Send Lead button
                            return (
                              <span className="text-gray-400 font-medium text-xs select-none">-</span>
                            );
                          }

                          // 4. Otherwise (not sent, not failed, not pending -> e.g. N/A or undefined) -> Display "-"
                          return (
                            <span className="text-gray-400 font-medium text-xs select-none">-</span>
                          );
                        };

                        return (
                          <div
                            key={row._id}
                            style={{ height: `${rowHeight}px` }}
                            className={`w-full flex flex-col justify-start items-center border-b border-black/[0.06] transition-colors duration-150 ${
                              isOpen ? 'bg-[#c9e2f1]' : ''
                            }`}
                          >
                            <div className="h-[58px] min-h-[58px] flex items-center justify-center w-full">
                              {renderAction()}
                            </div>
                            {isOpen && <div className="flex-1 w-full bg-[#c9e2f1]" />}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Send Simple Lead Modal */}
                  <SendSimpleLeadModal
                    isOpen={Boolean(selectedLeadForSend)}
                    onClose={() => setSelectedLeadForSend(null)}
                    lead={selectedLeadForSend}
                    onLeadSentSuccess={(apiResult) => {
                      if (selectedLeadForSend?._id) {
                        updateLeadState(selectedLeadForSend._id, {
                          pushed_to_simple: 1,
                          simple_verification: 1
                        });
                      }
                      toast.success(apiResult?.message || 'Lead sent to Simple Energy');
                      setSelectedLeadForSend(null);
                    }}
                    onLeadSentFailure={(apiResult) => {
                      if (selectedLeadForSend?._id) {
                        // A Duplicate is not a failed push: show it as Duplicate right away, not Failed
                        updateLeadState(selectedLeadForSend._id, apiResult?.duplicate
                          ? { pushed_to_simple: 4, simple_verification: 4 }
                          : { pushed_to_simple: 3, simple_verification: 2 });
                      }
                      toast.error(apiResult?.message || 'Failed to dispatch lead to Simple Energy');
                      setSelectedLeadForSend(null);
                    }}
                  />
                </div>
              ) : (
                <div className="text-center text-2xl font-bold h-full flex items-center justify-center">No columns selected</div>
              )
            ) : (
              /* Standard Single Table Layout for all other lead types */
              <TableContainer component={Paper} className="p-5 !pt-7 roundedOutSideglobal overflow-x-auto overflow-y-auto h-[calc(100%-68px)] shadow-global default-scrollbar !bg-[rgb(229_243_251_/_var(--tw-bg-opacity,_1))]">
                {selectedColumns.length > 0 ? (
                  <Table aria-label="collapsible table">
                    <TableHead
                      // className="rounded-outSideglobal shadow-global table-shadow-specific"
                      className="rounded-outSideglobal shadow-global table-shadow-specific !sticky top-0 !bg-[rgb(229_243_251_/_var(--tw-bg-opacity,_1))] z-10"
                    >
                      <TableRow className="border-none removed-border">
                        <TableCell align="left" className="border-none removed-border flex" />
                        <TableCell key={"No"} align="left" className="border-none removed-border" >No</TableCell>
                        {filteredColumns.map((col) => (
                          <TableCell key={col.uid} align="left" className="border-none removed-border whitespace-nowrap">
                            {col.name}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody className="border-none removed-border w-full text-center">
                      {currentRows?.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={filteredColumns.length + 2} align="center">
                            No rows to display.
                          </TableCell>
                        </TableRow>
                      ) : (
                        currentRows?.map((row, index) => (
                          <Row key={row.id} row={row} columns={filteredColumns} index={index} currentPage={currentPage} HandleLeadDetails={HandleLeadDetails} pageLimit={parseInt(pageLimit, 10)} leadType={leadType} handleGetLeadDetails={handleGetLeadDetails} handleVIewLeadDetailsInaccordion={handleVIewLeadDetailsInaccordion} isFetchingleadDetails={isFetchingleadDetails} leadDetailsMap={leadDetailsMap} loadingId={loadingId} handleGetRecordingUrl={handleGetRecordingUrl} recordingUrls={recordingUrls} loadingRecordingById={loadingRecordingById} noRecordingIds={noRecordingIds} />
                        ))
                      )}
                    </TableBody>
                  </Table>
                ) : (<div className="text-center text-2xl font-bold h-full flex items-center justify-center">No columns selected</div>)}
              </TableContainer>
            )}

            {/* Pagination Controls */}
            {selectedColumns.length > 0 && (
              <div className="pagination-wrapper w-full flex items-center justify-between mt-4">
                <div className="flex items-center justify-center w-[200px] gap-1">
                  <p>Show</p>
                  <Select
                    aria-label="Select entries per page"
                    className="max-w-[90px] bg-black!  border-gray-100 rounded-[13px]"
                    // items={pageLimitsNumber}
                    placeholder="Page size"
                    color='custom-bg'
                    variant="bordered"
                    defaultSelectedKeys={['10']}
                    selectedKeys={[pageLimit]}
                    onSelectionChange={(keys) => {
                      const newLimit = Array.from(keys)[0]; // Hero UI returns a Set, so convert it to array
                      setPageLimit(newLimit);
                      setCurrentPage(1);
                      onPageClick(1, newLimit);
                    }}
                  >
                    {pageLimitsNumber.map((item) => (
                      <SelectItem key={item.key} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </Select>
                  <p>Entries</p>
                </div>
                <Box display="flex w-full" justifyContent="center" mt={2}>
                  <Pagination
                    key={currentPage}
                    color='success'
                    classNames={{
                      wrapper: "",
                      item: "",
                      cursor:
                        "bg-success text-white",
                    }}
                    size={(currentPage > 100 || currentPage > '100') ? 'lg' : 'md'}
                    isCompact
                    showControls
                    total={totalPages}
                    page={currentPage}
                    onChange={(page) => handlePageChange(page)}
                  />
                </Box>
              </div>
            )}
          </Box>
          <LeadHistoryModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            leadHistory={leadData}
            title={modalTitle}
          />
        </>
      ) : (
        <>
          <div className="text-center h-full flex items-center justify-center text-3xl font-bold">No records found.</div>
        </>
      )
      }
      {openLeadView && (
        <LeadViewModal
          title={'Lead History'}
          isOpen={openLeadView}
          onOpen={() => setOpenLeadView(true)}
          onClose={() => setOpenLeadView(false)}
          modalFooter={false}
        // handleConfirmUpdate={confirmApplyFilter}
        >
          <div className="flex flex-col gap-[5px]">
            {isfetching ? (
              <>
                <div className="w-full flex flex-col gap-2">
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                  <Skeleton className="w-full h-[50px] p-2 px-4" />
                </div>
              </>
            ) : (
              (leadType === 'Dialshree' || leadType === 'Dialshreeinbound') ? (
                < GetCommonLeadsDetails leadDetails={leadDetails} />
              ) : (
                < GetLeadDetails leadDetails={leadDetails} handleVIewLeadDetailsInaccordion={handleVIewLeadDetailsInaccordion} leadDetailsMap={leadDetailsMap} />
              )
            )}

          </div>
        </LeadViewModal>
      )}
    </>
  )
}

export default LeadData;
